module.exports = __webpack_public_path__ + "static/img/no.0b41df77.svg";